import action from './action'
import login from './login'

const log = {
  action, login
}

export default log

export { action, login }